import { useTranslation } from "react-i18next";
import classes from "./KesalahjaPromo.module.css";

export const KesalahjaPromo = () => {
	const { i18n } = useTranslation();
	const isFinnish = i18n?.language?.includes("fi");

	return (
		<div className={classes.wrapper}>
			<img src={`${process.env.PUBLIC_URL}/campaign.png`} alt="" className={classes.bgImage} />

			<div className={classes.overlay}>
				<img
					src={`${process.env.PUBLIC_URL}/kotikino_no_bg.png`}
					alt="Kotikino"
					className={classes.logo}
				/>

				<div className={classes.card}>
					<span className={classes.domain}>KOTIKINO.FI</span>

					<h1 className={classes.title}>
						KOTIKINON
						<br />
						KESÄLAHJA
					</h1>

					<p className={classes.subtitle}>
						{isFinnish
							? "Kuukausiveloitus uusille ja vanhoille asiakkaille"
							: "Monthly subscription for new and existing customers"}
					</p>

					<p className={classes.price}>
						vain <span className={classes.priceAmount}>2,99 €</span> /kk
					</p>

					<p className={classes.terms}>
						{isFinnish
							? "KOSKEE VELOITUKSIA 1.6.2025 – 30.6.2026 (normaalihinta 9,99 €/kk)"
							: "APPLIES TO CHARGES 1.6.2025 – 30.6.2026 (normal price 9.99 €/month)"}
					</p>
				</div>
			</div>
		</div>
	);
};
